import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  CardContent,
  Collapse,
  IconButton,
  Divider,
} from "@mui/material";
import {
  useDeleteNewletterMutation,
  useGetUserInfoOnyQuery,
  useCreateNewsletterEmailRecordMutation,
  useGetNewsletterEmailRecordQuery,
  useGetAllClientNewsLetterSmsQuery,
} from "../../../Api/attoDeskApi";
import {
  INewsletterGmail,
  IUserAdmin,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/UnsubscribePopup";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import Pagination from "../../../Components/Pagination";
import { Link } from "react-router-dom";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import dayjs, { Dayjs } from "dayjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FcOk, FcCancel } from "react-icons/fc";
import { SlLike } from "react-icons/sl";
import { SlDislike } from "react-icons/sl";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MailOffIcon from "@mui/icons-material/MailOutline";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }: any) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCoursing, setSelectedCoursing] =
    useState<INewsletterGmail | null>(null);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<INewsletterGmail | null>(null);
  const [expandedTemplateId, setExpandedTemplateId] = useState<string | null>(
    null
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const { data, isLoading, isError, refetch } =
    useGetAllClientNewsLetterSmsQuery({
      searchText: currentSearchQuery,
      id: "",
    });

  const [newEmail, { isLoading: createEmaliRecordLoading }] =
    useCreateNewsletterEmailRecordMutation();

  const { data: emailRecodData, isLoading: emailRecordIsLoading } =
    useGetNewsletterEmailRecordQuery({
      searchText: "",
      id: "",
    });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleOpenDeletePopup = (coursing: INewsletterGmail) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const emailRecordList = useMemo(() => {
    return data?.data as INewsletterGmail[];
  }, [data?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.staff}`);
    });
    return map;
  }, [userList]);

  const [deleteCategory] = useDeleteNewletterMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Unsubscribed successfullyy");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to unsubscribed");
      }
    } catch (error) {
      showErrorMessage("Failed to unsubscribed");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: INewsletterGmail[] = Array.isArray(data?.data)
    ? (data?.data as INewsletterGmail[])
    : [];

  const handleAddProductClick = () => {
    navigate("/newsletters/create");
  };

  const handleAddClientType = () => {
    navigate("/client/newsletters");
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card} sx={{ minHeight: 400 }}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={3}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={4}
                md={4}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>Sms</Typography>
              </Grid>
              <Grid
                item
                lg={8}
                md={8}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Mobile Number or Subject.."
                      sx={{ width: "100%" }}
                      size="small"
                      className={classes.searchTextField}
                    />
                  </Grid>
                  <Grid item>
                    <Link
                      to={`/client/newsletters`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        // variant="contained"
                        className={classes.addNewButton}
                        onClick={handleAddClientType}
                      >
                        Client
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={3} p={2}>
              {emailRecordList?.length ? (
                emailRecordList
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((template) => (
                    <Grid item xs={12} md={12} lg={12} key={template.id}>
                      <Link
                        to={`/client/newsletters/sms/view/${template.id}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Card
                          variant="outlined"
                          className={classes.card}
                          onMouseEnter={() =>
                            setExpandedTemplateId(template.id)
                          }
                          onMouseLeave={() => setExpandedTemplateId(null)}
                          sx={{
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                            "&:hover": {
                              backgroundColor: "#f7f7f7",
                            },
                          }}
                          onClick={() =>
                            navigate(`/client/newsletters/view/${template.id}`)
                          }
                        >
                          <CardContent sx={{ cursor: "pointer" }}>
                            {/* Header Row: To Email + Expand Icon */}
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Grid item>
                                <Grid container spacing={1} direction="column">
                                  <Grid item>
                                    <Typography
                                      variant="subtitle1"
                                      fontWeight={600}
                                    >
                                      From:
                                      {formatPhoneNumberForDisplay(
                                        template.fromMobileNumber
                                      )}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              {template?.created_at && template?.created_by && (
                                <Grid item>
                                  <Grid
                                    container
                                    spacing={1}
                                    direction="column"
                                  >
                                    <Grid item>
                                      <Typography
                                        variant="subtitle1"
                                        color="textSecondary"
                                      >
                                        {`${
                                          dayjs(template?.created_at).format(
                                            "MMM-D, YYYY hh:mm A"
                                          ) || ""
                                        } | ${userMap.get(
                                          template?.created_by
                                        )}`}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {/* <Grid item>
                              <ExpandMore
                                expand={expandedTemplateId === template.id}
                                onClick={() => toggleExpand(template.id)}
                                aria-expanded={
                                  expandedTemplateId === template.id
                                }
                              >
                                <ExpandMoreIcon />
                              </ExpandMore>
                            </Grid> */}
                            </Grid>
                            <Grid
                              container
                              spacing={1}
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Grid item xs={12} sm={8}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                  noWrap
                                >
                                  Message: {template.message}
                                </Typography>
                              </Grid>

                              <Grid item xs={12} sm="auto">
                                {template.status === "Success" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <CheckCircleIcon
                                        sx={{ color: "green" }}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <Typography
                                        variant="body2"
                                        sx={{ color: "green" }}
                                      >
                                        Sent Successfully - Delivered to all
                                        clients
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : template.status === "Partial Failure" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <WarningAmberIcon
                                        sx={{ color: "orange" }}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <Typography
                                        variant="body2"
                                        color="warning.main"
                                      >
                                        Partial Failure - Some mobile number
                                        failed to send
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : template.status ===
                                  "No mobile number Found" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <MailOffIcon sx={{ color: "orange" }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="body2" color="error">
                                        No Mobile Number Found - Newsletter
                                        could not be sent
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : template.status ===
                                  "Partial - No mobile number" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <ReportProblemIcon
                                        sx={{ color: "orange" }}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <Typography
                                        variant="body2"
                                        color="warning.main"
                                      >
                                        Partial Delivery - Some clients don't
                                        have an mobile number
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : template.status === "Failed" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <CancelIcon sx={{ color: "red" }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="body2" color="error">
                                        Failed to Send
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <CancelIcon sx={{ color: "red" }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="body2" color="error">
                                        {template?.status || "Failed to Send"}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Link>
                    </Grid>
                  ))
              ) : (
                <Grid item xs={12}>
                  <Typography textAlign="center">
                    No mobile numbers found.
                  </Typography>
                </Grid>
              )}

              {isError && (
                <Grid item xs={12}>
                  <Typography textAlign="center">
                    Error fetching data
                  </Typography>
                </Grid>
              )}
              {!isError && (
                <Grid
                  spacing={5}
                  p={"18px"}
                  py={4}
                  justifyContent={"end"}
                  container
                  textAlign={"center"}
                  alignContent={"center"}
                  alignItems={"center"}
                >
                  <Grid
                    sx={{
                      textAlign: "end",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Pagination
                      count={coursings.length}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      onPageChange={handleChangePage}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
